"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SearchHeader;
exports.styles = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var styles = function styles(theme) {
  return {
    /**
     * Styles applied to the root element.
     */
    root: {
      backgroundColor: theme.palette.primary.main,
      padding: theme.spacing(6, 2, 2, 2),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _styles.makeStyles)(styles, {
  name: 'RSFSearchHeader'
});
/**
 * A element to be placed at the top of a [SearchDrawer](/apiReference/search/SearchDrawer).
 */

function SearchHeader(_ref) {
  _ref = Object.assign({}, {}, _ref);
  var classes = _ref.classes,
      children = _ref.children;
  classes = useStyles({
    classes: classes
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, children);
}

SearchHeader.propTypes = {
  /**
   * Override or extend the styles applied to the component. See [CSS API](#css) below for more details.
   */
  classes: _propTypes["default"].object,

  /**
   * Children to be rendered inside the header.
   */
  children: _propTypes["default"].node
};
